// extracted by mini-css-extract-plugin
export var container = "_gc-0";
export var content = "_gc-3";
export var customerTitle = "_gc-4";
export var empty = "_gc-5";
export var gray = "_gc-6";
export var header = "_gc-7";
export var info = "_gc-8";
export var loading = "_gc-2";
export var loadingCard = "_gc-9";
export var oneLine = "_gc-a";
export var personName = "_gc-e";
export var pillContainer = "_gc-b";
export var selected = "_gc-1";
export var text = "_gc-c";
export var twoLines = "_gc-d";
export var unread = "_gc-f";
export var unreadIndicator = "_gc-g";